<template>
  <div class="wrapper">
    <div class="header">
      <div class="main">
        <!-- <p>全溯应用市场</p> -->
        <div class="heading">
          <span>{{ title }}</span>
          <van-icon name="arrow-left" class="icon" @click="goBack" />
          <span v-if="cancelType == 1" class="cancelbtn" @click="onCancel">删除成员</span>
        </div>
      </div>
    </div>
    <div class="fill"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '详情'
    },
    cancelType: {
      type: Number,
      default: 2
    },
    go: {
      default: -1
    }
  },
  methods: {
    goBack() {
      if (typeof this.go == 'number') {
        this.$router.go(this.go)
      } else {
        this.$router.push(this.go)
      }
    },
    onCancel() {
      this.$emit('onCancel')
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  .header {
    width: 100%;
    height: 50px;
    background: url(../../assets/imgs/top-bj.png) no-repeat center/100% 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    box-sizing: border-box;
    padding: 5px 13px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .main {
      p {
        font-size: 17px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 15px;
      }
      .heading {
        height: 34px;
        line-height: 34px;
        font-size: 15px;
        text-align: center;
        position: relative;
        color: #fff;
        font-weight: bold;
        .icon {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .cancelbtn {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .fill {
    height: 50px;
  }
}
</style>